module.exports = __webpack_public_path__ + "img/itob_downimg01.d89ebe0d.png";